module.exports = __webpack_public_path__ + "img/aej1n-66wvl.008.b3405411.png";